/**
 * Purchase Limit Modal Store
 *
 * Global state for the "purchase limit reached" modal so usePayment (or any caller)
 * can open it without rendering UI. The modal shows the limit message and a link
 * to Profile → Responsible Gaming.
 */

type PurchaseLimitModalState = {
  isOpen: boolean;
  message: string;
};

type Listener = () => void;

const defaultMessage =
  'You have set a purchase limit. This purchase would exceed your limit. You can change your limits in Profile → Responsible Gaming.';

class PurchaseLimitModalStore {
  private state: PurchaseLimitModalState = {
    isOpen: false,
    message: defaultMessage,
  };

  private listeners = new Set<Listener>();

  getState = (): PurchaseLimitModalState => this.state;

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  private notify = (): void => {
    this.listeners.forEach((l) => l());
  };

  open = (message?: string): void => {
    this.state = {
      isOpen: true,
      message: message ?? defaultMessage,
    };
    this.notify();
  };

  close = (): void => {
    this.state = { isOpen: false, message: defaultMessage };
    this.notify();
  };
}

export const purchaseLimitModalStore = new PurchaseLimitModalStore();
